var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "org-select-container" },
    [
      _c(
        "el-select",
        {
          ref: "selectIt",
          attrs: {
            title: _vm.selectedTitle,
            multiple: _vm.multiple,
            "collapse-tags": _vm.collapse,
            "popper-class": "org-select-popver",
            placeholder: _vm.placeholder,
            disabled: _vm.disabled,
            clearable: ""
          },
          on: { change: _vm.changeSelect, focus: _vm.closeIt },
          nativeOn: {
            click: function($event) {
              return _vm.clickHandler($event)
            }
          },
          model: {
            value: _vm.selectedArray,
            callback: function($$v) {
              _vm.selectedArray = $$v
            },
            expression: "selectedArray"
          }
        },
        _vm._l(_vm.options, function(item, index) {
          return _c("el-option", {
            key: index,
            attrs: { label: item.label, value: item.value }
          })
        }),
        1
      ),
      _vm.orgVisible
        ? _c("area-select-dialog", {
            ref: "orgSelect",
            attrs: {
              multiple: _vm.multiple,
              cityIds: _vm.defaultCitys,
              "org-dialog-visible": _vm.orgVisible,
              "root-org-id": _vm.rootOrgId,
              modalAppendToBody: _vm.modalAppendToBody,
              appendToBody: _vm.appendToBody,
              modal: _vm.modal
            },
            on: {
              confirm: _vm.handleConfirm,
              cancle: function($event) {
                _vm.orgVisible = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }